import * as yup from 'yup';

// TODO: Move this on CMS
export const callMeSchema = () =>
  yup.object({
    phoneNumber: yup
      .string()
      .required('Campo obbligatorio')
      .min(6, 'Inserire minimo 6 caratteri')
      .max(14, 'Inserire massimo 14 caratteri')
      .matches(/^[0-9]*$/, 'Inserire un numero valido'),
  });
